import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router';
import Iconify from 'src/components/Iconify';
import { verifyRules } from 'src/utils/functions';
import v2_actionCalendarios from 'src/actions/v2/calendario/v2_actionCalendarios';
import { ModalNovoCalendario } from './components/ModalNovoCalendario';
import { CALENDARIOS_DESIGN as D } from './Calendarios.design';

export default function CalendariosConfig({
  user,
  onCallback
}) {
  const navigate = useNavigate();
  const [list, setList] = useState([]);
  const [openCreate, setOpenCreate] = useState(false);

  async function getList() {
    try {
      const response = await v2_actionCalendarios(user.clienteId);
      if (response.status === 200) {
        setList(response.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    getList();
    onCallback();
  }, []);

  function openCalendario(id) {
    navigate({
      pathname: '/dashboard/configuracoes/calendario',
      search: '?id=' + id
    });
  }

  return (
    <div className={D.root} style={{ fontFamily: D.fontStack }}>
      <div className={D.stickyHeader}>
        <div className={D.container}>
          <div className={D.topbar}>
            <div className={D.topbarIdentity}>
              <div className="min-w-0">
                <h1 className={D.title}>Calendários</h1>
                <p className={D.subtitle}>
                  Horários de atendimento e agenda da equipe.
                </p>
              </div>
            </div>
            <div className={D.topbarActions}>
              <button type="button" onClick={() => setOpenCreate(true)} className={D.primaryButton}>
                Novo calendário
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className={`${D.container} pt-6 ${D.pageBody}`}>
        <div className={D.stack}>
          <div className={D.sectionHeader}>
            <div className={D.sectionHeaderMain}>
              <h2 className={D.sectionHeaderTitle}>Lista</h2>
              <p className={D.sectionHeaderSub}>
                Cada calendário define quando a equipe está disponível.
              </p>
            </div>
          </div>

          {list.length === 0 ? (
            <div className="bg-white border border-[#e7e7ec] rounded-[12px] overflow-hidden">
              <div className={D.emptyWrap}>
                <div className={D.emptyIcon}>
                  <Iconify icon="eva:calendar-outline" width={28} />
                </div>
                <p className={D.emptyTitle}>Nenhum calendário</p>
                <p className={D.emptyDesc}>Crie um calendário para definir horários de atendimento.</p>
                <button type="button" onClick={() => setOpenCreate(true)} className={`${D.link} mt-4`}>
                  Novo calendário
                </button>
              </div>
            </div>
          ) : (
            <div className={D.grid}>
              {list.map((item) => (
                <div key={item._id} className={D.card}>
                  <p className={D.cardTitle}>{item.name}</p>
                  <p className={D.cardMeta}>{item.source || 'Lais'}</p>
                  {verifyRules(user.rules, 'editar_canal') && (
                    <div className="mt-4 pt-4 border-t border-[#f0f0f3] flex items-center gap-2">
                      <button type="button" onClick={() => openCalendario(item._id)} className={D.ghostButton}>
                        Configurar
                      </button>
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      <ModalNovoCalendario
        open={openCreate}
        onOpenChange={setOpenCreate}
        user={user}
        onCallback={(id) => {
          setOpenCreate(false);
          openCalendario(id);
        }}
      />
    </div>
  );
}
